jQuery(document).ready(function($) {

  // $('#AddToCart-product-shinyleaf').attr('onclick', 'window.RevyUpsell && window.RevyUpsell.onAdd()').addClass('button-revy-ready');
  

  var slShopify = window.Shopify;
  console.log('slShopify',slShopify);

  if ($('#hand-sanitizer-set-with-natural-oils-shiny-leaf').length){
    $('.select-size').html('Select option:');
  }
  
  
  if (!$('.upsell-products-wrapper').length){
    var statusFormClick = false;
    var shouldPrevent = true;

    $('.shopify-product-form').submit(function (e) {

      console.log('shouldPrevent: ' + shouldPrevent);
      if (shouldPrevent === true) {
        e.preventDefault();
      }

      var clickMeInterval;

      clearInterval(clickMeInterval);

      var attr = $('.shopify-product-form').attr('data-revy-upsell-form-added');
      
      if (typeof attr !== typeof undefined && attr !== false) {

        console.log('Revy is ready!');

      }else{

        $('#AddToCart-product-shinyleaf').find('#AddToCartText-product-shinyleaf').html('PLEASE WAIT');

        console.log('Revy is not ready! Preventing!');
        var notReadyCount = 0;

        clickMeInterval = setInterval(function () {
          // Checking Until Ready
          var attr = $('.shopify-product-form').attr('data-revy-upsell-form-added');
          if (typeof attr !== typeof undefined && attr !== false) {
            console.log('Checker - Revy is ready!');
            clearInterval(clickMeInterval);
            $('#AddToCart-product-shinyleaf').click();
            console.log('Re-clicking...');
            $('#AddToCart-product-shinyleaf').find('#AddToCartText-product-shinyleaf').html('ADD TO CART');
          }else{
            console.log('Checker - Revy is not ready! Preventing!');
            notReadyCount++;

            if (notReadyCount >= 8){
              clearInterval(clickMeInterval);
              shouldPrevent = false;
              $('#AddToCart-product-shinyleaf').click();
            }
          }
          console.log('notReadyCount: ' + notReadyCount);
        }, 1000);

      }

    // var clickMeInterval;
    // 

    // if (typeof attr !== typeof undefined && attr !== false) {

    //   console.log('Revy is ready!');
      
    // }else{

    //   e.preventDefault();
    //   console.log('Revy is not ready! Preventing!');

    //   // Try to re-submit
    //   $('.shopify-product-form').submit();

    // }

  });


  }
  
  //

        /* 
        * Afterpay Link
        */
        var afterPayLink = $('.afterpay-link');
        var afterPayLinkCustom = $('.afterpay-link-custom');
        afterPayLinkCustom.click(function(e){
            e.preventDefault();
            afterPayLink.click();
        });


        var distance = 0;
        if ($('.shinyleaf-product-full-details-container').length){
          distance = $('.shinyleaf-product-full-details-container').offset().top;
        }
        

        $(window).scroll(function(){

          checkScrollPosition();
          checkReachedPosition();

        });


        
        $(window).load(function(){

          checkScrollPosition();
          checkReachedPosition();



          if ($(window).width() >= 768) {

            // checkVariationImages();
            
            var topSpace = $('.breadcrumb').outerHeight() / 2;

            var headerHeight = $('#shopify-section-header').outerHeight() + 15;
            $('.product-right-details').stickySidebar({
              topSpacing: headerHeight + topSpace,
              bottomSpacing: 30
            });
            $('.product-left-details').stickySidebar({
              topSpacing: headerHeight + topSpace,
              bottomSpacing: 30
            });
            
            $('.full-details-sidebar').stickySidebar({
              topSpacing: headerHeight,
              bottomSpacing: 300
            });

          } else {

          }

        });


        // function checkVariationImages(){
        //   // Check If Real Images
        //   // if ($('.shinyleaf-product-real-images').length) {
        //     if ($('.shinyleaf-product-real-images').length && $('#ProductSelect-product-shinyleaf').length) {
        //     console.warn('Real Images Are Showing');

        //     var currentVariation = $('#ProductSelect-product-shinyleaf option:selected').html();
        //     currentVariation = currentVariation.trim();
        //     console.warn(currentVariation);
        //     $('.shinyleaf-product-real-images').hide();
        //     if ($('#ProductSelect-product-shinyleaf option').length > 1) {
              
        //       var currentVariationElement = $('#xProductPhoto-product-shinyleaf [data-variant="' + currentVariation + '"]');
        //       currentVariationElement.show();
        //       $('.full-detail-sidebar-content').find('img').attr('src', currentVariationElement.first().find('img').attr('src'));
        //     }else{
        //       $('.shinyleaf-product-real-images').show();
        //       $('.full-detail-sidebar-content').find('img').attr('src', $('.shinyleaf-product-real-images').first().find('img').attr('src'));
        //     }

        //     // var topSpace = $('.breadcrumb').outerHeight() / 2;
        //     // var headerHeight = $('#shopify-section-header').outerHeight() + 15;
        //     // $('.product-right-details').stickySidebar({
        //     //   topSpacing: headerHeight + topSpace,
        //     //   bottomSpacing: 30
        //     // });

        //     // $('.product-left-details').stickySidebar({
        //     //   topSpacing: headerHeight + topSpace,
        //     //   bottomSpacing: 30
        //     // });


        //   }else{
        //     console.warn('real images - not available');
        //   }
        // }


        function checkReachedPosition(){
          var scrollTop = $(window).scrollTop();
          if (scrollTop >= distance - (distance * .15)) {
            $('body').addClass('reached');
          } else {
            $('body').removeClass('reached');
          }
        }


      function checkScrollPosition(){
        var scrollTop = $(window).scrollTop();
        // console.log('Scroll Top: ' + scrollTop);
        if (scrollTop > $('#shopify-section-header').outerHeight()) {
          $('body').addClass('scrolled');
        } else {
          $('body').removeClass('scrolled');
        }
      }

      $('.youtube-thumbnail-container').click(function(){
          var youtubeSource = $(this).attr('data-youtube');
          var youtubeHTML = '';
          youtubeHTML+='<div class="text-center preventOverflowContent">';
          youtubeHTML+='<iframe class="product-video" src="' + youtubeSource + '?autoplay=1&amp;rel=0&amp;showinfo=0" allowfullscreen=""></iframe>';
          youtubeHTML+='</div>';
          $(this).append(youtubeHTML).addClass('embeeded');
      });

      
      /* 
      * Primary Quantity Field
      */
      $(document).on('change','.primary-quantity-input', function(){

        var quantity = $(this).val()
        $('.secondary-quantity-input').val(quantity);
        $('.third-quantity-input').val(quantity);



        // setTimeout(() => {
        //     var price = $('.primary-product-price').html();
        //     $('.secondary-product-price').html(price); 
        // }, 500);
        
        // updateRewards();

        updateTotalPrice();

      });


    /* 
    * Secondary Quantity Field
    */
    $(document).on('change', '.secondary-quantity-input', function () {

        var quantity = $(this).val();
        $('.primary-quantity-input').val(quantity).change();
        $('.third-quantity-input').val(quantity).change();

        // setTimeout(() => {
        //     var price = $('.primary-product-price').html();
        //     $('.secondary-product-price').html(price);
        // }, 500);

        // updateRewards();
        updateTotalPrice();

    });


    /* 
    * Secondary Quantity Field
    */
    $(document).on('change', '.third-quantity-input', function () {

        var quantity = $(this).val();
        $('.primary-quantity-input').val(quantity).change();
        $('.second-quantity-input').val(quantity).change();


        // setTimeout(() => {
        //     var price = $('.primary-product-price').html();
        //     $('.secondary-product-price').html(price);
        // }, 500);

        // updateRewards();
        updateTotalPrice();

    });



    
    //Bind Price
    // $("body").on('DOMSubtreeModified', ".add-to-cart__price", function () {
    //     var price = $(this).html();
    //     alert(price)
    // });

    /*
    * Update price based from the quantity
    */
    function updateTotalPrice(){
      $(".add-to-cart__price").html($(".add-to-cart__price").html());
      // var price = $(".add-to-cart__price").html();
      // price = price.replace("$", "");
      // price = parseFloat(price);

      // var totalPrice = price * quantity;
      // $(".add-to-cart__price").html(totalPrice);

    }



    $("body").on('DOMSubtreeModified', ".upsell-add-to-cart ", function () {
      // $('.secondary-product-price').html($(this).html());
      // // $('.third-product-price').html($(this).html());


      // // Set Rewards Points
      // var price = $(this).html();
      // price = price.replace("$", "");
      // price = parseFloat(price);
      // var totalRewardPoints = price * 10;
      // totalRewardPoints = totalRewardPoints.toFixed(2);
      // $('.product-reward-points').html(totalRewardPoints);
      var price = $(this).find('.amount').html();

      if (typeof price !== 'undefined'){
        price = price.replace(slCurrencySymbol,'');
        price = parseFloat(price);

        // March 18, Fix for dis code min
        if (slShopify.currency.active !== 'USD'){
          var slCurrencyRate = slShopify.currency.rate;
          price = price / slCurrencyRate;
      }


        var totalRewardPoints = price * 10;
        totalRewardPoints = totalRewardPoints.toFixed(2);
        $('.product-reward-points').html(totalRewardPoints);
        // $('.secondary-product-price').html(price.toFixed(2));
      }
      

    });


    var currentActualPrice;

    $("body").on('DOMSubtreeModified', ".add-to-cart__price", function () {

        // Set Actual Price
        var price = $(this).html();
        price = price.replace(slCurrencySymbol,'');
        price = parseFloat(price);

        if (!isNaN(price)){
          
          currentActualPrice = price;

          var currentQuantity = $('.primary-quantity-input').val();
          var actualPrice = price * currentQuantity;
          $('.final__price').html(slCurrencySymbol + actualPrice.toFixed(2));

        }
        
    });


    // Clone Star Rating
    // $('.shinyleaf-mobile-star-rating').html($('.shinyleaf-product-reviews-container').html());
    //$('.shinyleaf-floating-star-rating').html($('.shinyleaf-product-reviews-container').html());

    
    // Mobile Content
    $('.shinyleaf-product-mobile-content').append($('.shinyleaf-product-title-container').html());
    $('.shinyleaf-product-mobile-content').append($('.shinyleaf-product-reviews-container').html());




    
    /* 
    * Primary Variation Dropdown
    */
    $(document).on('change', '#ProductSelect-product-shinyleaf', function () {
      if ($(this).val() != $('.single-secondary-option-selector').val()){
        $('.single-secondary-option-selector').val($(this).val());
      }

      // checkVariationImages();

    });

    /* 
    * Secondary Variation Dropdown
    */
    $(document).on('change', '.single-secondary-option-selector', function () {
        $('#ProductSelect-product-shinyleaf').val($(this).val()).change().click();
    });


    // Initialize magnific popup
    $('.open-popup-link').magnificPopup({
      type:'inline',
      midClick: true,
      fixedBgPos: false
    });
      
    
    $(document).on('click', '.subscription-detail-button',function(){
        //$('#open-subscription-details-popup').click();
      
        // Open directly via API
        $.magnificPopup.open({
          items: {
            src: $('.subcription-details-popup-container').html(), // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          },
          mainClass: 'mfp-fade'
        });
    });

      
    // Get Current Variation
    var productPageVersion2VariantSelector = $('.product-page-version-2 #AddToCartForm-product-shinyleaf .selector-wrapper select');
    if (productPageVersion2VariantSelector.length){
        var currentSelection = productPageVersion2VariantSelector.val();
        $('.product-page-variations-option > div').removeClass('active');
        $("[data-value*='" + currentSelection + "']").addClass('active');
    }

    // Set Current Variation
    $('.product-page-variations-option > div').click(function(){
        var currentSelection = $(this).attr('data-value');
        $('.product-page-variations-option > div').removeClass('active');
        $("[data-value*='" + currentSelection + "']").addClass('active');
        productPageVersion2VariantSelector.val(currentSelection);
        productPageVersion2VariantSelector.change();
        updateRewards();
    });


    

    /*
    * Let's Update Rewards Points
    */
    function updateRewards(){

      console.log('Updating Rewards');

      var price = $('#ProductPrice-product-shinyleaf span.money').text().replace(slCurrencySymbol, '');
      price = parseFloat(price);

      var quantity = $('.QuantityInput').val();
      quantity = parseFloat(quantity);

      var totalPrice = price * quantity;
      var totalRewardPoints = totalPrice * 10;
      totalRewardPoints = totalRewardPoints.toFixed(2);

      console.log('Price:' + price + ' | Quantity:' + quantity + ' | Total Price: ' + totalPrice + ' | Points:' + totalRewardPoints);
      $('.rewards-earn-points-container .points span').html(totalRewardPoints);
    }

              
    var productAccordion = $('.product-accordion');
    var productAccordionTitle = productAccordion.find('h3');
    var productAccordionContent = productAccordion.find('div');
    
    productAccordionTitle.each(function(i) {
      var productAccordionTitleText = $(this).text();
      var productAccordionContentText = $(this).next().html();
      
      $('.product-accordion .accordion-container').append( '<div class="accordion-item"><div class="accordion">'+ productAccordionTitleText +'<span></span></div><div class="container"><div class="content">'+ productAccordionContentText +'</div></div>' );
      
      $(this).next().remove();
      $(this).remove();
    });
    
    var productItemTotal = $('.accordion-item').length;    
    var productItemTotalHalf = Math.ceil(productItemTotal / 2);
    var productItemTotalHalfMinusOne = Math.ceil(productItemTotal / 2) - 1;
    
    $('.accordion-item:lt('+ productItemTotalHalf +')').wrapAll('<div class=" grid__item small--one-whole medium--one-half large--one-half"></div>');
    $('.accordion-item:gt('+ productItemTotalHalfMinusOne +')').wrapAll('<div class=" grid__item small--one-whole medium--one-half large--one-half"></div>');
    
    $('.accordion').accordion({
      defaultOpen: 'section1',
      cookieName: 'accordion_nav'
    });
      
      
    /* Add to Cart Float on Scroll */

      var resizeId;
      $(window).resize(function() {
          clearTimeout(resizeId);
          resizeId = setTimeout(doneResizing, 700);
      });

      function doneResizing(){
        var infoBar = $('#infoBar').outerHeight();
        $('.follow-scroll').css('top', infoBar);
      }
      
      function floatHeaderButton() {
        
        var element = $('.follow-scroll'),
            originalY = element.offset().top,
            addButton = $('#AddToCart-product-shinyleaf'),
            productImage = $('.product__photo.slick-current img').data('mfp-src');

        $('.float-product-image').remove();
        element.prepend('<img class="float-product-image" src="'+productImage+'" alt="">');

        // Should probably be set in CSS; but here just for emphasis

        $(window).on('scroll', function(event) {
          var infoBar = $('#infoBar').outerHeight(),
              scrollTop = $(window).scrollTop();
          element.css('top', infoBar);
          
          if( scrollTop < originalY ) {
            element.css('top', '0');
            element.removeClass('float-active');
          } else {
            element.addClass('float-active');
          }
        });
        
      }
      
      // FAQ Search
      if ($('.accordion-container').length){
        
        $('.accordion-container').after('<div class="faq-no-result">No results found!</div>');
        
        $.expr[":"].contains = $.expr.createPseudo(function (arg) {
          return function (elem) {
            return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
          };
        });

        var faqSearchField = $('.faq-search-field');
        var faqNoResult = $('.faq-no-result');
      
        var faqSearchFieldValue = '';
        var faqContainers;
        var faqAccordionItems = $('.accordion-item');

        faqSearchField.keyup(function () {
          faqSearchFieldValue = $(this).val();
          console.log(faqSearchFieldValue);
          faqAccordionItems.appendTo( $( '.faq-filter-wrap' ) );
          faqAccordionItems.hide();
          if (faqSearchFieldValue != '') {
            // Not Empty
            var foundFAQ = $('.accordion-item:contains("' + faqSearchFieldValue + '")');
            foundFAQ.show();
            if (foundFAQ.length == 0){
              faqNoResult.show();
            }else{
              faqNoResult.hide();
            }
          }else{
            // Empty
            faqAccordionItems.show();
            faqNoResult.hide();
          }
        });
      }
      

      $('.sl-recurring-container #subcribe-now').click(function(){
        $('button#AddToCart-product-shinyleaf').click();

        setTimeout(function(){
          window.location.href = 'https://www.shinyleaf.com/cart/'
        },1000);
        
      });


        var purchasedType = 'onetime';
        $(document).on('change','.product-page-form-wrapper.product-page-form-wrapper-version-2 input[name="purchase_type"]', function(){
            purchasedType = $(this).val();
            console.warn('I ran');
            if (purchasedType != 'onetime') {
                $('.afterpay-paragraph').hide();
                $('#AddToCart-product-shinyleaf').attr('onclick','');
            }else{
                $('.afterpay-paragraph').show();
                $('#AddToCart-product-shinyleaf').attr('onclick', 'window.RevyUpsell && window.RevyUpsell.onAdd()');
            }
        });

        /*
        * Floating SL Add to Cart Button
        */
        $('.sl-add-to-cart-button').click(function () {
            $('.upsell-add-to-cart').click();
        });


        /*
        * Floating SL Add to Cart Button
        */
        $('.sl-floating-add-to-cart-button').click(function () {
            $('body').addClass('open-popup');
        });

        /*
        * Floating SL Add to Cart Button
        */
        $('.sl-popup-checkout-container .close-button').click(function () {
            $('body').removeClass('open-popup');
        });




        // $(document).on('change','.sl-custom-purchase-type', function(){
        //     purchasedType = $(this).val();
        //     $('input[value="' + purchasedType +'"]').click();
        // });
        $(document).on('change', '.sl-custom-purchase-type', function () {

          purchasedType = $(this).val();
          $('input[value="' + purchasedType + '"]').click();

          // 1.0.1
          if (purchasedType == 'onetime') {
            $('.sl-custom-purchase-delivery').prop('checked', false);
          }

        });

        // 1.0.1
        $(document).on('change', '.sl-custom-purchase-delivery', function () {

          // Click Auto Delivery
          $('input[value="autodeliver"]').click();

          var option = $(this).val();
          $('.rc_label__deliver_every select').val(option);
          $('.sl-custom-auto-deliver').val(option);

        });


        $('.sl-custom-auto-deliver').change(function(){
            var option = $(this).val();
            $('.rc_label__deliver_every select').val(option);
            $('.sl-custom-auto-deliver').val(option);
        });


        

        var slAppURL = 'https://app.shinyleafcosmetics.com';


        // Clear UTM sessionStorage

        sessionStorage.removeItem('utm_source');
        sessionStorage.removeItem('utm_campaign');
        sessionStorage.removeItem('utm_medium');


        /*
        * Save queries to sessionStorage
        */
        var queryToSessionStorage = function (settings) {
          var reset = true; //settings && settings.reset ? settings.reset : false;
          var self = window.location.toString();
          var querystring = self.split("?");
          if (querystring.length > 1) {
            var pairs = querystring[1].split("&");
            for (i in pairs) {
              var keyval = pairs[i].split("=");
              if (reset || sessionStorage.getItem(keyval[0]) === null) {
                sessionStorage.setItem(keyval[0], keyval[1]);
              }
            }
          }
        }
        queryToSessionStorage();

        /*
        * Check UTM Data
        */
        var checkUTMData = function () {

          var utmSource = sessionStorage.getItem('utm_source');
          var utmMedium = sessionStorage.getItem('utm_medium');
          var utmCampaign = sessionStorage.getItem('utm_campaign');

          if (utmSource || utmMedium || utmCampaign) {

            utmSource = decodeURI(utmSource);
            utmMedium = decodeURI(utmMedium);
            utmCampaign = decodeURI(utmCampaign);

            var postData = {
              advanced_cart_discounts: 'source',
              utm_source: utmSource,
              utm_medium: utmMedium,
              utm_campaign: utmCampaign
            }

            $.get(slAppURL, postData, function (response) {

              var $data = $.parseJSON(response);

              console.warn($data);

              if ($data.status) {

                DISCOUNT_CODE_DETAILS = $data;
                var discountCode = $data.fields.discount_code;
                var appliesTo = $data.fields.applies_to;
                var firstLine = $data.fields.product_discount_details_1st_line;
                var secondLine = $data.fields.product_discount_details_2nd_line;

                setCookie('discount_code', discountCode, 9999);

                switch (appliesTo) {
                  
                  case 'entire_order':
                  implementDiscountDetails(firstLine, secondLine);
                  break;

                  case 'specific_products':


                    var specificProducts = $data.fields.applies_to_specific_products;

                    if (specificProducts.length) {

                      $.each(specificProducts, function (key, value) {
                        var specificProduct = value.split('~');
                        var specificProductHandle = specificProduct[0];

                        if (afterpay_product.handle == specificProductHandle) {
                          implementDiscountDetails(firstLine, secondLine);
                        }

                      });

                    }

                  break;
                  
                }

              }else{
                checkDiscountCodeCookie();
              }

            });

          } else {

            checkDiscountCodeCookie();

          }

        }

        checkUTMData();
        function checkDiscountCodeCookie(){
          if (getCookie('discount_code') != null || getCookie('discount_code') != "") {

            var postData = {
              advanced_cart_discounts: 'init',
              discount_code: getCookie('discount_code')
            }

            $.get(slAppURL, postData, function (response) {

              var $data = $.parseJSON(response);

              console.warn($data);

              if ($data.status) {

                DISCOUNT_CODE_DETAILS = $data;

                var appliesTo = $data.fields.applies_to;
                var firstLine = $data.fields.product_discount_details_1st_line;
                var secondLine = $data.fields.product_discount_details_2nd_line;

                switch (appliesTo) {
                  case 'entire_order':
                    implementDiscountDetails(firstLine, secondLine);
                  break;

                  case 'specific_products':
                    

                    var specificProducts = $data.fields.applies_to_specific_products;

                    if (specificProducts.length){

                      $.each(specificProducts,function(key,value){
                        var specificProduct = value.split('~');
                        var specificProductHandle = specificProduct[0];

                        if (afterpay_product.handle == specificProductHandle){
                          implementDiscountDetails(firstLine, secondLine);
                        }

                      });

                    }

                  break;


                }

                $('.utm-get-discount-container').attr('data-value', $data.fields.discount_value_percentage);
                $('.utm-get-discount-container').attr('data-applies-to', $data.fields.applies_to);
                $('.utm-get-discount-container').attr('data-type', $data.fields.discount_type);


              }

            });

          }
        }


        function unescapeHTML(escapedHTML) {
          if (typeof escapedHTML !== 'undefined'){
            return escapedHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
          }else{
            return '';
          }
          
        }


        /*
        * Implement Discount Details
        */

        function implementDiscountDetails(firstLine, secondLine) {

          $('.utm-get-discount-container').remove();
          var html = '';
          html += '<div class="utm-get-discount-container">';
          html += '<p class="title">' + unescapeHTML(firstLine) + '</p>';
          html += '<p class="content">' + unescapeHTML('USE CODE: <strong>' + getCookie('discount_code') + '</strong>') + '</p>';
          html += '</div>';

          $('.sl-floating-bar-container').prepend(html);
          $('.shinyleaf-product-description-container').after(html);
          
          $('#product-page-discount-details').html('');
          $('#product-page-discount-details').append('<div id="left-product-details">' + html + '</div>');
          // $('#product-page-discount-details').append('<div id="right-product-details">' + guarantedHTML + '</div>');

        }


        function setCookie(name,value,days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days*24*60*60*1000));
                expires = "; expires=" + date.toUTCString();
            }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
        }
        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for(var i=0;i < ca.length;i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1,c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
            }
            return null;
        }
        function eraseCookie(name) {   
            document.cookie = name+'=; Max-Age=-99999999;';  
        }

        /* 
        * Product Section Navigation
        */
        var productSectionNavigation = $('.product-section-navigations-container');
        if (productSectionNavigation.length) {
            var productSectionNavigationActions = productSectionNavigation.find('.product-section-navigation');

            productSectionNavigationActions.click(function () {
                productSectionNavigationActions.removeClass('active');
                var action = $(this).attr('data-action');
                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#section-" + action).offset().top - 100
                }, 2000);
            });

        }


        $(window).load(function () {
          initProductSliders();
        });
        $(window).resize(function () {
          initProductSliders();
        });


        /*
        * Product Images - Mobile
        */
        function initProductSliders(){
          if ($(window).width() < 620) {
            $('#xProductPhoto-product-shinyleaf').not('.slick-initialized').slick({
              dots: true,
              autoplay: true,
              autoplaySpeed: 3000,
            });
          }else{

            if ($('#xProductPhoto-product-shinyleaf.slick-initialized').length){
              $('#xProductPhoto-product-shinyleaf.slick-initialized').slick('unslick');
            }
            
          }
        }


        /*
        * Change Revy Upsell
        */



      $('.full-ingredients-container .action').click(function () {

        $(this).toggleClass('active');

        if ($(this).hasClass('active')) {
          $(this).html('<p>Ocultar la lista completa de ingredientes</p>');
        } else {
          $(this).html('<p>Ver lista completa de ingredientes</p>');
        }
        $('.full-ingredients-container .content').slideToggle();
      });

      
      var shinyleafRealImages = $('.shinyleaf-product-real-images');
      if (shinyleafRealImages.length && $('#ProductSelect-product-shinyleaf option').length > 1) {

        /* 
        * Secondary Variation Dropdown
        */
        $(document).on('change', '.single-floating-option-selector', function () {
          $('#ProductSelect-product-shinyleaf').val($(this).val()).change();
          // $('#ProductSelect-product-shinyleaf').val($(this).val()).change().click();
          checkVariationImages();
        });

        if ($('.shinyleaf-product-real-images').length) {
          checkVariationImages();
        }

        $(document).on('change', '#ProductSelect-product-shinyleaf', function () {
          checkVariationImages();
        });

        function checkVariationImages() {
          // Check If Real Images
          if ($('.shinyleaf-product-real-images').length && $('#ProductSelect-product-shinyleaf').length) {

            console.warn('Real Images Are Showing');

            var currentVariation = $('#ProductSelect-product-shinyleaf option:selected').attr('data-title');
            currentVariation = currentVariation.trim();
            console.warn(currentVariation);

            $('.shinyleaf-product-real-images').hide();

            if ($('#ProductSelect-product-shinyleaf option').length > 1) {

              console.warn('heyyy');

              var currentVariationElement = $('#xProductPhoto-product-shinyleaf [data-variant="' + currentVariation + '"]');
              currentVariationElement.show();
              $('.full-detail-sidebar-content').find('img').attr('src', currentVariationElement.first().find('img').attr('src'));

            } else {

              $('.shinyleaf-product-real-images').show();
              $('.full-detail-sidebar-content').find('img').attr('src', $('.shinyleaf-product-real-images').first().find('img').attr('src'));

            }

            if ($(window).width() < 620) {
              handleVariationSlider();
              console.warn('SHOWING ALL BECAUSEA ITS MOBILE!');
            } else {
              console.warn('ITS NOT MOBILE');
            }


            // $('.full-detail-sidebar-content').find('img').attr('src', currentVariationElement.first().find('img').attr('src'));

          } else {
            console.warn('real images - not available');
          }
        }


        // Get available variants
        var availableVariations = [];
        var shinyleafProductImageContainer = $('.shinyleaf-product-mobile-content');


        // Init Real Imagew
        shinyleafRealImages.each(function () {

          if (!$(this).hasClass('slick-cloned')) {

            var currentVariant = $(this).attr('data-variant');
            currentVariant = currentVariant.replace(/\s/g, '_');
            currentVariant = currentVariant.replace('(', '_');
            currentVariant = currentVariant.replace(')', '_');
            currentVariant = currentVariant.replace('+', '_');

            var variantImageURL = $(this).find('img').attr('src');
            var currentVariantClass = 'variant-identifier-' + currentVariant;
            var currentVariantSliderClass = '.' + currentVariantClass + '-slider';

            // Create Slider Wrapper
            if (!$(currentVariantSliderClass).length) {
              shinyleafProductImageContainer.after('<div class="variant-identifier-slider ' + currentVariantClass + '-slider"></div>');
            }

            // Append Slider
            if ($(currentVariantSliderClass).length) {

              var variantSliderHTML = $(this).html();

              variantSliderHTML = variantSliderHTML.replace('data-variant=', 'data-variant-x=');

              // $(currentVariantSliderClass).append('<div class="variant-slide">' + variantSliderHTML + '</div>');
              $(currentVariantSliderClass).append($(this).clone().wrap('<div class="variant-slide"></div>'));


            }
          }

        });


        // Custom CSS
        $('.variant-slide').css('position', 'relative');
        $('.variant-identifier-slider').css('margin-top', '30px');
        $('.variant-identifier-slider').css('margin-bottom', '0px');


        initVariationSlider();
        handleVariationSlider();


        $(window).resize(function () {
          handleVariationSlider();
        });


        function initVariationSlider() {
          // Init Slider

          //$('.variant-identifier-slider.slick-initialized').slick('unslick');

          if ($('.variant-identifier-slider').length > 1) {
            $('.variant-identifier-slider').each(function () {

              $(this).find('.hide-real-images').removeClass('hide-real-images');
              $(this).find('.shinyleaf-product-real-images').removeClass('shinyleaf-product-real-images');
              

              $(this).not('.slick-initialized').slick({
                dots: true,
                autoplay: true,
                autoplaySpeed: 3000,
              });
            });
            //$('.variant-identifier-slider').hide();
          }
        }

        // Add Event Handler Variant Change
        // $(document).on('change', '#ProductSelect-product-shinyleaf', function () {
        //   handleVariationSlider();
        //   console.log('handleVariationSlider();');
        // });

        function handleVariationSlider() {

          if ($('.variant-identifier-slider').length > 1) {

            var currentVariation = $('#ProductSelect-product-shinyleaf option:selected').attr('data-title');
            currentVariation = currentVariation.trim();
            //currentVariation = currentVariation.replace(' ', '_');
            currentVariation = currentVariation.replace(/\s/g, '_');
            currentVariation = currentVariation.replace('+', '_');
            currentVariation = currentVariation.replace(')', '_');
            currentVariation = currentVariation.replace('(', '_');

            var currentVariantClass = 'variant-identifier-' + currentVariation;
            var currentVariantSliderClass = '.' + currentVariantClass + '-slider';

            $('.variant-identifier-slider').addClass('remove-from-the-web')

            if ($(window).width() > 768) {
              $('.shinyleaf-product-slides-container-XX').show();
            } else {
              $('.shinyleaf-product-slides-container-XX').hide();
              $(currentVariantSliderClass).removeClass('remove-from-the-web');
              $(currentVariantSliderClass).find('.product__photo').show();
              $(currentVariantSliderClass).find('.product__photo img').each(function(){
                $(this).attr('src', $(this).attr('data-mfp-src'));
              });
            }

          }
        }


      }

  // /*
  // * Mascara Brush
  // */
  // if ($('#disposable-eyelash-mascara-brush-shiny-leaf').length){

  //   $('#ProductSelect-product-shinyleaf').hide();
  //   $('.variant-selection p').hide();

  //   selectMascaraVariant();

  //   $(document).on('click', '.product-color-picker', function () {
  //     $('.product-color-picker').removeClass('product-color-picker-selected');
  //     $(this).addClass('product-color-picker-selected');
  //     $('[data-color="' + $(this).attr('data-color') + '"]').addClass('product-color-picker-selected');

  //     selectMascaraVariant();
  //   });

  //   $(document).on('change blur', 'select[name="mascara_brush_size"]', function () {

  //     $('select[name="mascara_brush_size"]').val( $(this).val() );

  //     selectMascaraVariant();
  //   });

  //   function selectMascaraVariant() {
  //     var brushPack = $('.section-product-details select[name="mascara_brush_size"] option:selected').text();
  //     var brushColor = $('.section-product-details .product-color-picker-selected').attr('data-color');
  //     var brushVariantText = brushPack + ' - ' + brushColor;
  //     console.warn('Brush Variant: ' + brushVariantText);
  //     $('#ProductSelect-product-shinyleaf option:contains("' + brushVariantText + '")').prop('selected',true);
  //     $('#ProductSelect-product-shinyleaf').trigger('change');

  //     if ($('.slick-initialized.slick-slider').length) {
  //       $('.slick-initialized.slick-slider').slick('slickGoTo', 0);
  //     }

  //     // Update Sidebar Price
  //     $('.secondary-product-price').html($('.upsell-add-to-cart .amount').html());

  //   }

  //   // Clone to Sidebar
  //   $('.product-color-picker-container').clone().insertAfter('.full-detail-sidebar-content .image');

  // }


  /*
    * Product Color Variant
    */
  var productColorVariantModule = {
    init: function () {
      if ($('.product-color-picker-container').length) {


        // Hide Original Variant Selector
        $('#ProductSelect-product-shinyleaf').hide();
        $('.variant-selection p').hide();

        productColorVariantModule.selectColorVariant();

        $(document).on('click', '.product-color-picker', function () {
          $('.product-color-picker').removeClass('product-color-picker-selected');
          $(this).addClass('product-color-picker-selected');
          $('[data-color="' + $(this).attr('data-color') + '"]').addClass('product-color-picker-selected');

          productColorVariantModule.selectColorVariant();
        });

        $(document).on('change blur', '.product-color-picker-container select', function () {

          $('.product-color-picker-container select').val($(this).val());

          productColorVariantModule.selectColorVariant();
        });

        // Clone to Sidebar
        $('.product-color-picker-container').clone().insertAfter('.full-detail-sidebar-content .image');
      }
    },
    selectColorVariant: function () {
      var variantText = ''; 
      var variantColor = $('.product-color-picker-wrapper .product-color-picker-container .product-color-picker-selected').attr('data-color');

      if ($('.product-color-picker-wrapper .product-color-picker-container select').length){
        var variantPack = $('.product-color-picker-wrapper .product-color-picker-container select option:selected').text();
        variantText = variantPack + ' - ' + variantColor;
      }else{
        variantText = variantColor;
      }
      
      

      console.warn('Variant Color Text: ' + variantText);
      $('#ProductSelect-product-shinyleaf option:contains("' + variantText + '")').prop('selected', true);
      $('#ProductSelect-product-shinyleaf').trigger('change');

      if ($('.slick-initialized.slick-slider').length) {
        $('.slick-initialized.slick-slider').slick('slickGoTo', 0);
      }

      // Update Sidebar Price
      $('.secondary-product-price').html($('.upsell-add-to-cart .amount').html());

    }
  }

  productColorVariantModule.init();


  /*
  * Special Promo for Bariatric
  */

  if($('#btn-bariatric-special-discount').length && window.location.hash && window.location.hash == '#special-promo') {

    $('body').addClass('product-special-discount');

    var bariatricSpecialPromoPopup = '';
    initBariatricSpecialDiscountPopup();
    

    function initBariatricSpecialDiscountPopup(){
      $.getJSON('/products/bariatric-multivitamin-with-45mg-iron-once-a-day-capsule-for-post-weight-loss-surgery-sleeve-mini-gastric-bypass-special-promotion.js', function(response){
          
        bariatricSpecialPromoPopup += '<div class="white-popup bariatric-special-discount-popup">';
        bariatricSpecialPromoPopup += '<div class="white-popup-content">';
        bariatricSpecialPromoPopup += '<h2>BARIATRIC MULTIVITAMIN WITH IRON</h2>';
        bariatricSpecialPromoPopup += '<h3>SPECIAL PROMOTION: <strong>INTERNATIONAL SHIPPING FEE INCLUDED</strong></h3>';
        bariatricSpecialPromoPopup += '<div class="bariatric-special-discount-variants"><div class="row">';

        $.each(response.variants, function(key, variant){
          bariatricSpecialPromoPopup += '<div class="col-md-4">';
          bariatricSpecialPromoPopup += '<div class="bariatric-special-discount-variant">';
          bariatricSpecialPromoPopup += '<div class="bariatric-image"><img class="img-fluid" src="' + variant.featured_image.src + '"/></div>';
          bariatricSpecialPromoPopup += '<div class="bariatric-title">' + variant.public_title + '</div>';
          bariatricSpecialPromoPopup += '<div class="bariatric-action"><a class="btn btn-generic" href="https://www.shinyleaf.com/cart/' + variant.id + ':1">BUY NOW <span>|</span> ' + slCurrencySymbol + (variant.price / 100) + '</a></div>';
          bariatricSpecialPromoPopup += '</div>';
          bariatricSpecialPromoPopup += '</div>';
        });

        bariatricSpecialPromoPopup += '</div></div>';
        bariatricSpecialPromoPopup += '<p class="text-center bariatric-notes">*Exclusive promotion for the Bariatric Multivitamin products only for international shipping only - limited time offer.*</p>';
        bariatricSpecialPromoPopup += '</div>';
        bariatricSpecialPromoPopup += '</div>';

        
        $('#btn-bariatric-special-discount').show().click();

      });
    }

    $(document).on('click','#btn-bariatric-special-discount', function(){
      $.magnificPopup.open({
          items: {
              src: bariatricSpecialPromoPopup, 
              type: 'inline'
          }
      });

    });

  } else {
    // Fragment doesn't exist
  }


  /* Sharer */
  var productHandle = $('.upsell-products-wrapper').attr('data-handle');
  var shareHTML = '';
  shareHTML+= '<div class="shinyleaf-share-container">';
  shareHTML+= '<img class="img-fluid" src="https://cdn.shopify.com/s/files/1/0009/7684/6907/files/shinyleaf-share-icon.png?v=1616487373" alt="Share Now" title="Share Now"/>';
  shareHTML+= '<span>Share</span>';
  shareHTML+= '</div>';

  $('.shinyleaf-product-reviews-container').append(shareHTML);
  $('.shinyleaf-product-mobile-content').append(shareHTML);

  $(document).on('click','#shinyleaf-share-popup i',function(){
    var sharer = $(this).attr('data-share');
    var sharerHandle = productHandle;
    var shareLink = '';
    
    switch (sharer){

      case 'facebook':
        shareLink = 'https://www.facebook.com/sharer/sharer.php?u=https://www.shinyleaf.com/products/' + sharerHandle;
        window.open(
          shareLink,
          '_blank' // <- This is what makes it open in a new window.
        );
      break;

      case 'twitter':
        shareLink = 'https://twitter.com/intent/tweet?url=https://www.shinyleaf.com/products/' + sharerHandle + '&text=';
        window.location.href = shareLink;
      break;

      case 'whatsapp':
        shareLink = 'https://wa.me/?text=https://www.shinyleaf.com/products/' + sharerHandle + '';
        window.location.href = shareLink;
      break;

      case 'mail':
        shareLink = 'mailto:?body=https://www.shinyleaf.com/products/' + sharerHandle + '';
        window.location.href = shareLink;
      break;

    }
    

  });
  $(document).on('click','.shinyleaf-share-copy button',function(){
  

    var copyText = document.getElementById("share_link");
    
    copyText.select();
    document.execCommand("copy");

    $(this).addClass('active').html('Copied');
    

    setTimeout(function(){
      $('.shinyleaf-share-copy button').removeClass('active').html('Copy');
      $('.shinyleaf-share-copy input').focus();
    },3000);

  });

  $(document).on('click','.shinyleaf-share-container',function(){

    var popupHTML = '';
    popupHTML+= '<div id="shinyleaf-share-popup" class="white-popup">';
    popupHTML+= '<h2>SHARE NOW</h2>';
    popupHTML+= '<ul>';
      popupHTML+= '<li><i data-share="facebook" class="fab fa-facebook"></i></li>';
      popupHTML+= '<li><i data-share="twitter" class="fab fa-twitter"></i></li>';
      popupHTML+= '<li><i data-share="whatsapp" class="fab fa-whatsapp"></i></li>';
      popupHTML+= '<li><i data-share="mail" class="fa fa-envelope"></i></li>';
    popupHTML+= '</ul>';
    popupHTML+= '<div class="shinyleaf-share-copy">';
    popupHTML+= '<input id="share_link" name="share_link" readonly type="text" value="https://www.shinyleaf.com/products/' + productHandle + '"/>';
    popupHTML+= '<button type="button">Copy</button>';
    popupHTML+= '</div>';
    

    popupHTML+= '</div>';


    $.magnificPopup.open({
      items: {
          src: popupHTML, 
          type: 'inline'
      }
    });


  });


  function copyToClipboard(text) {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
  }


  // Update
  var handles = ['dht-blocker-shampoo','biotin-shampoo','castor-oil-shampoo','bariatric-multivitamin-with-iron-for-90-capsules'];
  var validOptionsCount = 0;
  var validOptionPreviousPrice = 0;
  var validOptionSinglePrice = 0;

  if (handles.indexOf($('.upsell-products-wrapper').attr('data-handle')) !== -1) {

      $('body').addClass('body-buy-more-save-more');

      $('#ProductSelect-product-shinyleaf option').each(function(){
          
          if (!$(this).hasClass('option-sold-out')){

            var optionValue = $(this).val();
            var oldOptionText = $(this).text();
            oldOptionText = oldOptionText.trim();

            var currentDataPrice = $(this).attr('data-price');

            if (validOptionsCount == 0){
              validOptionSinglePrice = currentDataPrice;
              var newOptionText= oldOptionText +  ' (BUY MORE, SAVE MORE)';
              $(this).text(newOptionText);
              $('.single-secondary-option-selector option[value="' + optionValue + '"]').html(newOptionText);
            }else{

              var optionQuantity = 1;
              switch (oldOptionText){
                case '1 Bottle':
                  optionQuantity = 1;
                break;
                case '2 Bottles':
                  optionQuantity = 2;
                break;
                case '3 Bottles':
                  optionQuantity = 3;
                break;
                case '6 Months Supply':
                  optionQuantity = 2;
                break;
                case '1 Year Supply':
                  optionQuantity = 4;
                break;
              }

              var savePrice =  (validOptionSinglePrice * optionQuantity) - currentDataPrice;
              savePrice = savePrice / 100;
              savePrice = savePrice.toFixed(2);
              var newOptionText = oldOptionText + ' - Save ' + slCurrencySymbol + savePrice ;

              if ($('#ProductSelect-product-shinyleaf option').not('.option-sold-out').length == (validOptionsCount + 1) ){
                newOptionText+=' - (Lowest Price)';
              }
              $(this).text(newOptionText);
              $('.single-secondary-option-selector option[value="' + optionValue + '"]').html(newOptionText);
            }

          

            validOptionPreviousPrice = currentDataPrice;
            validOptionsCount++;

        
          }

      });
  }


  // Check shinyleaf-product-real-images
  if ($('.sold-out-container').length){
    var currentVariation = $('.shinyleaf-product-real-images').first().attr('data-variant');
    $('.shinyleaf-product-real-images').hide();
    $('[data-variant="' + currentVariation + '"]').show();

  }
  
  
  
});